import { render } from "./ToggleRadio.vue?vue&type=template&id=72239942"
import script from "./ToggleRadio.vue?vue&type=script&lang=js"
export * from "./ToggleRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__